import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface FiltersState {
  taskName: string;
  vendorPseudoName: string;
  stage: string;
  role: string;
  status: string;
  expertId?: string;
  gigSourceId?: string;
}

const initialState: FiltersState = {
  taskName: "",
  vendorPseudoName: "",
  stage: "",
  role: "",
  status: "",
  expertId: "",
  gigSourceId: "",
};

const filtersSlice = createSlice({
  name: "filters",
  initialState,
  reducers: {
    setFilters(state, action: PayloadAction<FiltersState>) {
      return { ...state, ...action.payload };
    },
    resetFilters() {
      return initialState;
    }
  }
});

export const { setFilters, resetFilters } = filtersSlice.actions;
export default filtersSlice.reducer;
